import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../data/sushiContent';
export function ComparisonSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="comparison-title" data-id="element-47" data-mp="3e7kei2q6n4n8">
      <div className="mx-auto max-w-3xl px-5" data-id="element-48" data-mp="34fo3xs6wtm24">
        <h2 id="comparison-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-49" data-mp="34empddqoqhfn">
          Lo que cambia con Sushi Fácil en Casa
        </h2>

        <div className="mt-8 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-x-4 border-b border-charcoal-600 pb-2 text-[9px] font-semibold uppercase tracking-[0.2em] sm:grid-cols-[8rem_minmax(0,1fr)_minmax(0,1fr)] sm:gap-x-6" data-id="element-50" data-mp="2vhcfnwtin0cu">
          <span className="hidden sm:block text-muted" data-id="element-51" data-mp="op1tqyi9y4gv" />
          <span className="text-muted" data-id="element-52" data-mp="omfnr3b17x0r">Sin el sistema</span>
          <span className="text-champagne" data-id="element-53" data-mp="jqgwn7ybk0wn">Con el sistema</span>
        </div>

        <ul className="divide-y divide-charcoal-600 border-b border-charcoal-600" data-id="element-54" data-mp="3ael5nr65yhi6">
          {comparisonRows.map(row => <li key={row.aspect} className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] items-start gap-x-4 py-4 sm:grid-cols-[8rem_minmax(0,1fr)_minmax(0,1fr)] sm:gap-x-6" data-id="element-55" data-mp="3ehhggvpgp9bk">
              <p className="col-span-2 mb-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory-300 sm:col-span-1 sm:mb-0 sm:self-center" data-id="element-56" data-mp="35g9xdkviof22">
                {row.aspect}
              </p>
              <p className="flex items-start gap-2 text-[13.5px] leading-snug text-body sm:self-center" data-id="element-57" data-mp="1yhydmiyquud">
                <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-58" data-mp="3jfj3frq0dssb" />
                {row.without}
              </p>
              <p className="flex items-start gap-2 text-[13.5px] font-medium leading-snug text-ivory-50 sm:self-center" data-id="element-59" data-mp="kpiv03wm2ear">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-60" data-mp="um188cjtpj22" />
                {row.with}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}